import type React from 'react';

import { cn } from '@/lib/utils';

export const emptyValueClassName = 'text-gray400';
export const emptyValueText = 'n/a';

const placeholderValues = new Set(['', '-', '--', 'n/a']);

export const isEmptyDisplayValue = (value: unknown): value is null | undefined | string =>
  value == null || (typeof value === 'string' && placeholderValues.has(value.trim().toLowerCase()));

type EmptyValueProps = {
  children?: React.ReactNode;
  className?: string;
};

export const EmptyValue = ({ children = emptyValueText, className }: EmptyValueProps) => (
  <span className={cn(emptyValueClassName, className)}>{children}</span>
);
